import {Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, QueryList, ViewChildren, HostListener} from '@angular/core';
import {UserService} from '../../shared/services/user.service';
import {Router} from '@angular/router';
import { NavbarService } from 'src/app/shared/services/navbar.service';
import {HttpClient} from '@angular/common/http';
import {IWGSharedService} from '../../shared/services/shared.service';
import { MatDialog } from '@angular/material/dialog';
import { ContactInfoComponent } from 'src/app/contact-info/contact-info.component';
import { ContactusComponent } from '../contactus/contactus.component';
import { MatMenuTrigger } from '@angular/material/menu';


@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    constructor(public router: Router,
                public userService: UserService, public nav: NavbarService,
                private http: HttpClient, private sharedService: IWGSharedService, public dialog: MatDialog
    ) {
        // sharedService.isMyRateDirty = false;
    }

    @Input() deviceXs: boolean;

    activeStatus = 'dashboard';

     EORDisabled = false;
     ComplianceDisabled = false;
     AORDisabled = false;
     InvoicesDisabled = false;
     CountryGuidesDisabled = false;
     HasWorkerProfile = false;

     ShowCountryGuides = true;
     ShowiWGInvoices = true;
     ShowCompliance = true;
     ShowAOR = true;
     ShowAORQuotes = true;
     ShowEOR = true;
     ShowComplianceQuotes = true;
     ShowContractorInvoices = true;
     ShowUSEORQuotes = false;
     pageTitle = '';
     UserRole = '';
     userServiceInitials: any;
     originatorEv: any;
    userInitials = '';

    showQuoteEstimator1 = true;
    ShowEOREstimator = false;
    ShowEORQuotes = true;
    ShowInvoice = true;
    ShowMyTalent = false;
    IsWorker = false;
    ShowWorkerProfile = false;
    isFirstTime = true;
    @ViewChild('navToolBar') navToolBar;
    isNavActive:boolean=false;
    navMenuName:string='';
    @ViewChildren(MatMenuTrigger) trigger: QueryList<MatMenuTrigger>;

    @HostListener('window:scroll', [])
    scrollHandler() {
        for (let index = 0; index < this.trigger.toArray().length; index++) {
            this.trigger.toArray()[index].closeMenu();
        }
    }
    
    ngAfterContentChecked(){
        this.getRoleDetails();        
    }

    ngOnInit() {
        this.nav.activeModuleSubject$.subscribe((res:any) => {
            if(res) {
                this.isNavActive = res.isVisible;
                this.navMenuName = res.activeMenu;
            }
        });
        if (this.userService.getEOREstimatorAccess()) {
            this.ShowEOREstimator = true;
        } else {
            this.ShowEOREstimator = false;
        }
        this.ShowInvoice = true;        
    }

    

    getRoleDetails()
    {
        if (this.userService.isSignedIn()) 
        {
        if( this.UserRole==null ||  this.UserRole =='')
        {                 
            if(this.isFirstTime)
            {
                this.isFirstTime=false;
                this.userService.getRoleFromClaim().subscribe(result=>
                {  
                    if(result!=null && result.data!=null)
                    {                        
                        this.UserRole = this.userService.getRole();//result.data.text;
                        this.generateNavLinks();
                    }
                });
        }
        }else{
            this.generateNavLinks();
        }
    }
}

    generateNavLinks() {
        if (this.userService.isSignedIn()) {
            this.EORDisabled = this.userService.getEORDisabled();
            this.ComplianceDisabled = this.userService.getComplianceDisabled();
            this.AORDisabled = this.userService.getAORDisabled();
            this.InvoicesDisabled = this.userService.getInvoicesDisabled();
            this.CountryGuidesDisabled = this.userService.getCountryGuidesDisabled();
            this.ShowUSEORQuotes = (this.userService.getIsSalesManager() || this.userService.getIsSales());
            this.userInitials = this.userService.getInitials();
            this.HasWorkerProfile = this.userService.hasWorkerProfile(); 
            //this.sharedService.HasWorkerProfile.next(this.HasWorkerProfile);
            if (this.UserRole != 'Manager' && this.userService.getMyTalentAccess()) {
                this.ShowMyTalent = true;
            } 
            if (this.UserRole === 'Worker') {
                this.IsWorker = true;
                if (this.userService.getMyTalentDataConsent()) {
                    this.ShowWorkerProfile = true;
                }
                this.ShowCountryGuides = false;
                this.ShowiWGInvoices = false;
                // this.ShowCompliance = false; //Hided on 01/04/2019 to show the Compliance for the workers
                // this.ShowAOR = true;
                this.ShowEORQuotes = false;
                this.ShowEOREstimator = false;
                this.ShowComplianceQuotes = false;
                this.ShowAORQuotes = false;
                if (this.AORDisabled) {
                    this.ShowInvoice = false;
                }
            } else {
                this.ShowCountryGuides = true;
                this.ShowiWGInvoices = true;
                // this.ShowCompliance = true; //Hided on 01/04/2019 to show the Compliance for the workers
                // this.ShowAOR = true;
                this.ShowEOR = true;
                this.ShowComplianceQuotes = true;
                this.ShowAORQuotes = true;
                if (this.InvoicesDisabled) {
                    this.ShowiWGInvoices = false;
                }
                if (this.AORDisabled) {
                    this.ShowContractorInvoices = false;
                }
                if (this.ShowiWGInvoices === true || this.ShowContractorInvoices === true) {
                    this.ShowInvoice = true;
                } else {
                    this.ShowInvoice = false;
                }
            }
      

            // if (($state.current.data.pageTitle)) {
            //     this.pageTitle = $state.current.data.pageTitle;
            // }

            this.userServiceInitials = this.userService.getInitials();
        }
    }
    showContactInfo = (event) => {
        if (this.sharedService.getMyRateDirty()) {
            if (this.isConfirm()) {
                this.sharedService.setMyRateDirty(false);
                this.displayContactInfo(event);
            }
        }
        else {
            this.displayContactInfo(event);
        }
    }
    isConfirm(): any {
        return confirm('Are you sure you want to leave the page without submitting?');
    }
    getAttribute(attr, item): any {
        return item.getAttribute(attr);
    }

    stateIncludes(mask): any {
        // return $state.includes(mask);
    }

    stateIncludesAny(maskList): any {
        // return _(maskList).split(',').some(stateIncludes);
    }

    openMenu = ($mdOpenMenu, ev) => {
        this.originatorEv = ev;
        // $mdOpenMenu(ev);
    }

    logoutUser = () => {
        if (this.sharedService.getMyRateDirty() || this.sharedService.getAssignmentQuestionDirty()) {
            if (this.isConfirm()) {
                this.sharedService.setMyRateDirty(false);
                this.sharedService.setAssignmentQuestionDirty(false);
                // this.userService.accountLogOff().then(() => {
                this.userService.deleteToken();
                this.router.navigate(['login']);
                // });
            }
        }
        else {
            // this.userService.accountLogOff().then(() => {
                this.userService.deleteToken();
                this.router.navigate(['login']);
            // });
        }
    }
    LogOutCall(): any {
        try {
            this.http.get('/Account/LogOff').toPromise()
            .then(() => {
                // Successfully logged out.
            });
        }
        catch (e) {
        }
    }
    showQuoteEstimator = (ev) => {
        if (this.sharedService.getMyRateDirty()) {
            if (this.isConfirm()) {
                this.sharedService.setMyRateDirty(false);
                if (this.userService.getShowEOREstimator()) {
                    this.router.navigate(['/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c'], {queryParams: {service: 1, global_scope: 2}});
                    // $state.go('app.quote-estimator', {service: 1, global_scope: 2, quoteId: '7b57522b-d0d6-403c-b524-1f0e2f24003c'}); // INTL EOR
                } else {
                    alert(this.userService.getNotSupportedtext());
                }
            }
            else {
                return;
            }
        }
        else {
            if (this.userService.getShowEOREstimator()) {
                this.router.navigate(['/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c'], {queryParams: {service: 1, global_scope: 2}});
                // $state.go('app.quote-estimator', {service: 1, global_scope: 2, quoteId: '7b57522b-d0d6-403c-b524-1f0e2f24003c'}); // INTL EOR
            } else {
                alert(this.userService.getNotSupportedtext());
            }
        }
    }

    OnClick = (selNav, context, theService) => {

        const notSupportedtext = 'This service is not currently activated for your account. Please contact your iWorkGlobal Client Solutions representative for information about expanding your services.';

        if (theService === 1 && this.EORDisabled) {
            alert(notSupportedtext);
            return;
        }
        if (theService === 3 && this.ComplianceDisabled) {
            alert(notSupportedtext);
            return;
        }
        if (theService === 2 && this.AORDisabled) {
            alert(notSupportedtext);
            return;
        }
        if (context === 'invoices' && this.InvoicesDisabled) {
            alert(notSupportedtext);
            return;
        }     
        if (context === 'myGuides' && this.CountryGuidesDisabled) {
            alert(notSupportedtext);
            return;
        }

        this.activeNav(selNav);
        const rateDirtyException = ['my-talent-rate']

        if (this.sharedService.getMyRateDirty() && !rateDirtyException.includes(selNav)) {
            if (this.isConfirm()) {
                this.sharedService.setMyRateDirty(false);
                if (theService != null) {
                    this.router.navigate([context], {queryParams: {service: theService}});
                } else {
                    this.router.navigate([context]);
                }
            }
            else {
                return;
            }
        }
        else {
            if (theService != null) {
                this.router.navigate([context], {queryParams: {service: theService}});
            } else {
                this.router.navigate([context]);
            }
        }
    }
    OnDashboardclick = (ev) => {
        if (this.sharedService.getMyRateDirty()) {
            if (this.isConfirm()) {
                this.sharedService.setMyRateDirty(false);
                this.activeNav('dashboard')
                this.router.navigate(['/dashboard']);
            }
        }
        else {
            this.activeNav('dashboard');
            this.router.navigate(['/dashboard']);
        }
    }

  activeNav(type): void {
    this.activeStatus = type;
  }
  displayContactInfo = (ev) => {
    this.sharedService.isBlurredBg.next(true);
    const dialogRef = this.dialog.open( ContactInfoComponent, {
      panelClass: 'iwg-form-dialogfull'
    });
    dialogRef.afterClosed().subscribe( result => {
        this.sharedService.isBlurredBg.next(false);            
    });
    // QuoteDialogService.show(ev);
  }

  showContactUs($event, isLogin:boolean=true): void {
    this.sharedService.isBlurredBg.next(isLogin); 
    $event.preventDefault();
    const dialogRef = this.dialog.open(ContactusComponent, {
      width: 'auto',
      backdropClass: 'footerpopup'
    });
    dialogRef.afterClosed().subscribe( result => {
        this.sharedService.isBlurredBg.next(false); 
    });
  }
}
